<template>
  <a class="flex items-center" :href="block.form.file.url" target="_blank">
    <i class="fa fa-file fa-2x mr-2"></i>
    <div>{{block.form.caption ? block.form.caption : block.form.file.url}}</div>
  </a>
</template>

<script>
export default {
  props: {
    block: {}
  }
};
</script>

<style lang="scss" scoped></style>
